
export default {
  share: {
    'fullUrl': 'Teljes',
    'shortUrl': 'Rövid',
    'urlCopied': 'URL a vágólapra másolva.',
    'clickToCopy': 'Kattintson az URL másolásához',
    'share': 'Megosztás (kattintson a másoláshoz)',
    'shareLink': 'Link megosztása',
    'short': 'Rövid URL',
    'copyUrlInfo': 'A linket a böngésző címsorából is kimásolhatja.',
    'urlShortened': 'Rövidített URL',
    'shorteningNotPossible': 'Nem lehetett rövid URL-t generálni. Kérjük, használja a teljes URL-t',
    'embedCodeCopied': 'Beágyazási kód kimásolva',
    'embed': 'Beágyazás (kattintson a másoláshoz)',
    'embedInstructions': 'Ezzel a kóddal beágyazhatja az ORS-térképet a saját webhelyére'
  }
}
